import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { getCatchError } from '../../../getCatchError';
import { Action } from '../../../action';

const setGetPinsale = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await DefaultApi({
                params,
                method: 'get',
                url: urls.PINSALE
            });

            if (data?.status === 'success') {
                dispatch(Action.Pinsale.setGetPinsaleAction([
                    ...data.data
                ]));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetPinsale as setGetPinsale
}